import { SistemaResponse } from "./sistemaResponse"

export const SISTEMA_GET = 'SISTEMA_GET'
export const SISTEMAS_GET = 'SISTEMAS_GET'

export interface SistemaState {
    sistema: SistemaResponse | undefined
    sistemas: SistemaResponse[] | undefined
}

export interface SistemaAction {
    type: typeof SISTEMA_GET,
    payload: SistemaResponse
}

export interface SistemasAction {
    type: typeof SISTEMAS_GET,
    payload: SistemaResponse[]
}

export type SistemaActionTypes = SistemaAction | SistemasAction